import { Col, Input, Label, Row } from "reactstrap";
import React from "react";

/**
 * Task 24455 - staff-level details, captured while the user is being created.
 *
 * Everything on the previous step is the LOGIN (User): email, name, password
 * delivery. Everything here is the company-local Staff record (Staff.Id ==
 * User.Id) - who this person is inside this business. Without this step a new
 * user arrived with no job title and no phone number, and someone had to go
 * and fill them in on the staff screen afterwards.
 *
 * All of it is optional: none of it blocks creating the account.
 *
 * Change #100477 - the "copy from an existing user" picker and the dashboard,
 * menu and landing page fields moved back to the Default Options step, so
 * the copy can fill in the security roles alongside them in one place.
 */
const TabStaffDetails = ({
  createUpdateData,
  setCreateUpdateData,
  activeVerticalTab,
  setActiveVerticalTab,
}) => {
  const set = (key) => (e) =>
    setCreateUpdateData({ ...createUpdateData, [key]: e.target.value });

  return (
    <Row>
      <div>
        <h2>Staff Details</h2>
        <p className="text-muted mb-0">
          How this person appears inside your company. All optional — you can
          fill it in later from their staff profile.
        </p>
      </div>
      <hr />

      <Col lg={12} className={"p-2"}>
        <Label>Job Title</Label>
        <Input
          type="text"
          placeholder="e.g. Senior Technician"
          value={createUpdateData?.Staff_JobTitle || ""}
          onChange={set("Staff_JobTitle")}
        />
      </Col>

      <Col lg={6} className={"p-2"}>
        <Label>Telephone</Label>
        <Input
          type="text"
          placeholder="e.g. 01452 123456"
          value={createUpdateData?.Staff_ContactTelephoneNumber || ""}
          onChange={set("Staff_ContactTelephoneNumber")}
        />
      </Col>

      <Col lg={6} className={"p-2"}>
        <Label>Mobile</Label>
        <Input
          type="text"
          placeholder="e.g. 07700 900123"
          value={createUpdateData?.Staff_ContactMobileNumber || ""}
          onChange={set("Staff_ContactMobileNumber")}
        />
      </Col>

      <Col lg={12} className={"p-2"}>
        <Label>Contact Email</Label>
        <Input
          type="email"
          placeholder={
            createUpdateData?.User_Email
              ? `Defaults to ${createUpdateData.User_Email}`
              : "name@company.com"
          }
          value={createUpdateData?.Staff_ContactEmailAddress || ""}
          onChange={set("Staff_ContactEmailAddress")}
        />
        <small className="text-muted">
          Leave blank to use their login email. This is only the contact address
          on their staff record — it does not change how they sign in.
        </small>
      </Col>

      <Col lg={12} className={"p-2"}>
        <div className={"d-flex justify-content-between mt-2"}>
          <button
            type="button"
            className={"btn btn-primary"}
            onClick={() => setActiveVerticalTab(activeVerticalTab - 1)}
          >
            <i className="ri-arrow-left-line align-bottom me-1" />
            Back
          </button>
          <button
            type="button"
            className={"btn btn-success"}
            onClick={() => setActiveVerticalTab(activeVerticalTab + 1)}
          >
            Next
            <i className="ri-arrow-right-line align-bottom ms-1" />
          </button>
        </div>
      </Col>
    </Row>
  );
};

export default TabStaffDetails;
